import RectangularButton from 'components/elements/molecules/RectangularButton/RectangularButton';
import { pluralizeEntity, pluralizeEntityWithCount } from 'helpers';

export default function StepSummary({
  direction,
  selectedCourse,
  selectedTopics,
  selectedStudents,
  onConfirm,
}) {
  return (
    <div>
      <h4>We will sync the following:</h4>
      <p>
        <b>Course:</b> {selectedCourse?.name}
      </p>
      <p>
        <b>{pluralizeEntity(selectedTopics.length, 'Topic')}:</b>{' '}
        {selectedTopics.map((t) => t.name).join(', ')}
      </p>
      <p>
        <b>Roster:</b>{' '}
        {pluralizeEntityWithCount(selectedStudents.length, 'Student')}
      </p>

      <div className="d-flex justify-content-end">
        <RectangularButton
          className="btn btn-success"
          onClick={onConfirm}
          darkButton
        >
          Sync Now
        </RectangularButton>
      </div>
    </div>
  );
}
